import type { ReactNode } from 'react';

export const symbol_speed_4: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M441-323q35 17 68.5 4t41.5-48q20-78 39-157l38-158q3-12-8-17.5t-19 4.5q-48 66-97 131.5T407-434q-20 29-9 62.5t43 48.5ZM192-160q-18 0-33.5-8.5T134-193q-26-48-40-100T80-399q0-94.37 39.5-173.69Q159-652 225-708t149-78.5q83-22.5 168-8.5 11 2 16.5 12.5T561-760q-3 12-12.5 19t-21.5 5q-70-11-139 8.5T265-663q-56.72 47.9-90.86 116.03T140-399q0 48 12 93t36 86h584q25-41 36.5-86t11.5-93q0-75-29.5-139T710-649q-9-8-11-20.5t6-23q8-10.5 20.5-11.5t21.5 7q62 55 97.5 131.5T880-399q0 54.05-12.76 106.57Q854.48-239.91 827-193q-9 16-25.25 24.5T768-160H192Zm284-234Z"
		/>
	</svg>
);
